var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('Filters',{attrs:{"items":_vm.listMaster}}),_c('DataTable',{attrs:{"loading":_vm.loading,"items":_vm.listFiltered,"items-per-page":_vm.itemsPerPage},on:{"update:itemsPerPage":function($event){_vm.itemsPerPage=$event},"update:items-per-page":function($event){_vm.itemsPerPage=$event},"refresh":_vm.findAllProcess}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }